// start:ng42.barrel
import   './report-container.component';
import   './report-list.component';
// end:ng42.barrel

